// ═══════════════════════════════════════════════════════════════
// EMPTY STATE
// ═══════════════════════════════════════════════════════════════
import { Icons } from "./Icons";

export function EmptyState({ type }) {
  const labels = { image: "images", video: "videos", pdf: "PDFs" };
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", minHeight: 260, gap: 10, color: "#9ca3af" }}>
      {type === "image" && <Icons.Image />}
      {type === "video" && <Icons.Video />}
      {type === "pdf" && <Icons.Pdf />}
      <span style={{ fontSize: "13px", color: "#6b7280" }}>No {labels[type]} uploaded yet</span>
      <span style={{ fontSize: "11px", color: "#b0b5c0" }}>Go to Upload New to add {labels[type]}</span>
    </div>
  );
}
